import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	IMtdEmReportsItem,
	TGetMtdReportsRequest,
	TMtdReportsItemResponsePayload,
	TMtdStore,
	TAddCommentRequest,
	TGetMtdReportRequest,
	TSendMtdFileReportRequest,
	TGetMtdReportResponse,
	TCalculateMtdDataRequest,
	TDownloadMtdReportPdfRequest,
	TUpdateObligationsRequest,
	TUpdateObligationsResponse,
	THmrcManualProcessing,
} from './types';
// ==========================================:
export const initialState: TMtdStore = {
	mtdReports: null,
	mtdReportsIsLoading: false,
	mtdReport: null,
	mtdReportIsLoading: false,
	sendMtdFileReportIsLoading: false,
	calculateMtdDataIsLoading: false,
	downloadMtdReportPdfIsLoading: false,
	updateObligationsIsLoading: false,
	updateObligationsResponse: null,
	emLastMtdReports: null,
	emLastMtdReportsIsLoading: false,
	manualProcessing: null,
	manualProcessingIsLoading: false,
	updateManualProcessingIsLoading: false,
};

// ==========================================:
const mtd = createSlice({
	name: '@@mtd',
	initialState,
	reducers: {
		getMtdReportsRequest: (state: TMtdStore, _action: PayloadAction<TGetMtdReportsRequest>) => {
			const mtdState = state;
			mtdState.mtdReportsIsLoading = true;
		},
		getMtdReportsSuccess: (
			state: TMtdStore,
			action: PayloadAction<TMtdReportsItemResponsePayload<IMtdEmReportsItem>>,
		) => {
			const { payload } = action;
			const mtdState = state;
			mtdState.mtdReports = payload;
			mtdState.mtdReportsIsLoading = false;
		},
		getMtdReportRequest: (state: TMtdStore, _action: PayloadAction<TGetMtdReportRequest>) => {
			const mtdState = state;
			mtdState.mtdReportIsLoading = true;
			mtdState.mtdReport = null;
		},
		getMtdReportSuccess: (state: TMtdStore, action: PayloadAction<TGetMtdReportResponse>) => {
			const { payload } = action;
			const mtdState = state;
			mtdState.mtdReport = payload;
			mtdState.mtdReportIsLoading = false;
		},
		addMtdCommentRequest: (_state: TMtdStore, _action: PayloadAction<TAddCommentRequest>) => {},
		addMtdCommentSuccess: () => {},
		sendMtdFileReportRequest: (
			state: TMtdStore,
			_action: PayloadAction<TSendMtdFileReportRequest>,
		) => {
			const mtdState = state;
			mtdState.sendMtdFileReportIsLoading = true;
		},
		sendMtdFileReportSuccess: (state: TMtdStore) => {
			const mtdState = state;
			mtdState.sendMtdFileReportIsLoading = false;
		},
		calculateMtdDataRequest: (
			state: TMtdStore,
			_action: PayloadAction<TCalculateMtdDataRequest>,
		) => {
			const mtdState = state;
			mtdState.calculateMtdDataIsLoading = true;
		},
		calculateMtdDataSuccess: (state: TMtdStore) => {
			const mtdState = state;
			mtdState.calculateMtdDataIsLoading = false;
		},
		downloadMtdReportPdfRequest: (
			state: TMtdStore,
			_action: PayloadAction<TDownloadMtdReportPdfRequest>,
		) => {
			const mtdState = state;
			mtdState.downloadMtdReportPdfIsLoading = true;
		},
		downloadMtdReportPdfSuccess: (state: TMtdStore) => {
			const mtdState = state;
			mtdState.downloadMtdReportPdfIsLoading = false;
		},
		updateObligationsRequest: (
			state: TMtdStore,
			_action: PayloadAction<TUpdateObligationsRequest>,
		) => {
			const mtdState = state;
			mtdState.updateObligationsIsLoading = true;
			mtdState.updateObligationsResponse = null;
		},
		updateObligationsSuccess: (
			state: TMtdStore,
			action: PayloadAction<TUpdateObligationsResponse>,
		) => {
			const mtdState = state;
			mtdState.updateObligationsIsLoading = false;
			mtdState.updateObligationsResponse = action.payload;
		},
		updateObligationsFailure: (state: TMtdStore) => {
			const mtdState = state;
			mtdState.updateObligationsIsLoading = false;
		},
		getEmLastMtdReportsRequest: (
			state: TMtdStore,
			_action: PayloadAction<TGetMtdReportsRequest>,
		) => {
			const mtdState = state;
			mtdState.emLastMtdReportsIsLoading = true;
		},
		getEmLastMtdReportsSuccess: (
			state: TMtdStore,
			action: PayloadAction<TMtdReportsItemResponsePayload<IMtdEmReportsItem>>,
		) => {
			const mtdState = state;
			mtdState.emLastMtdReports = action.payload;
			mtdState.emLastMtdReportsIsLoading = false;
		},
		getEmLastMtdReportsFailure: (state: TMtdStore) => {
			const mtdState = state;
			mtdState.emLastMtdReportsIsLoading = false;
		},
		getManualProcessingRequest: (state: TMtdStore, _action: PayloadAction<number>) => {
			const mtdState = state;
			mtdState.manualProcessingIsLoading = true;
			mtdState.manualProcessing = null;
		},
		getManualProcessingSuccess: (
			state: TMtdStore,
			action: PayloadAction<THmrcManualProcessing>,
		) => {
			const mtdState = state;
			mtdState.manualProcessing = action.payload;
			mtdState.manualProcessingIsLoading = false;
		},
		getManualProcessingFailure: (state: TMtdStore) => {
			const mtdState = state;
			mtdState.manualProcessingIsLoading = false;
		},
		updateManualProcessingRequest: (
			state: TMtdStore,
			_action: PayloadAction<THmrcManualProcessing>,
		) => {
			const mtdState = state;
			mtdState.updateManualProcessingIsLoading = true;
		},
		updateManualProcessingSuccess: (
			state: TMtdStore,
			action: PayloadAction<THmrcManualProcessing>,
		) => {
			const mtdState = state;
			mtdState.manualProcessing = action.payload;
			mtdState.updateManualProcessingIsLoading = false;
		},
		updateManualProcessingFailure: (state: TMtdStore) => {
			const mtdState = state;
			mtdState.updateManualProcessingIsLoading = false;
		},

		mtdInitState: () => initialState,
	},
});

export default mtd.reducer;
export const {
	getMtdReportsRequest,
	getMtdReportsSuccess,
	addMtdCommentRequest,
	addMtdCommentSuccess,
	getMtdReportRequest,
	getMtdReportSuccess,
	sendMtdFileReportRequest,
	sendMtdFileReportSuccess,
	calculateMtdDataRequest,
	calculateMtdDataSuccess,
	downloadMtdReportPdfRequest,
	downloadMtdReportPdfSuccess,
	updateObligationsRequest,
	updateObligationsSuccess,
	updateObligationsFailure,
	getEmLastMtdReportsRequest,
	getEmLastMtdReportsSuccess,
	getEmLastMtdReportsFailure,
	getManualProcessingRequest,
	getManualProcessingSuccess,
	getManualProcessingFailure,
	updateManualProcessingRequest,
	updateManualProcessingSuccess,
	updateManualProcessingFailure,
	mtdInitState,
} = mtd.actions;
